const NEW_VERSION_DOWNLOADED = 'NEW_VERSION_DOWNLOADED'

export const newVersion = (state = false, action) => {
    switch (action.type) {
        case NEW_VERSION_DOWNLOADED:
            return true

        default:
            return state
    }
}

export const newVersionDownloaded = () => ({ type: NEW_VERSION_DOWNLOADED })


// WEBPACK FOOTER //
// ./src/reducers/newVersion/index.js